import {
  AGREE_COOKIE_PREFERENCES_EVENT,
  OPEN_COOKIE_PREFERENCES_EVENT,
} from '../consts';

type SUBSCRIBE_EVENTS =
  | typeof OPEN_COOKIE_PREFERENCES_EVENT
  | typeof AGREE_COOKIE_PREFERENCES_EVENT;

export function subscribeCookiePreferences(
  event: SUBSCRIBE_EVENTS,
  handler: () => void
): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  window.addEventListener(event, handler);

  return () => {
    window.removeEventListener(event, handler);
  };
}
